const newArea = {
  snackbar: "Your update is ready",
  name: "Area Name",
  save: "Save",
  cancel: "Cancel",
  area: "Area",
  formTitle: "New Area",
  confirm: "Are you sure you want to delete this item?",
  close: "Close",
  delete: "Delete",
  selectPlant: "Select Plant",
  selectCompany: "Select Company"
};
export default newArea;
